export type ChatLegalConsentsAnswers = {
  acceptAgb: boolean
  acceptPrivacy: boolean
  acceptGuideline: boolean
  contactViaEmail: boolean
  contactViaWhatsapp: boolean
  acceptConfirmData: boolean
}

export type ChatLegalConsentsApplyStore = {
  chatLegalConsents: ChatLegalConsentsAnswers | null
  applyOnboardingWidgetTool: (tool: string, data: Record<string, unknown>) => Promise<boolean>
}

export const toLegalConsentsToolData = (
  answers: ChatLegalConsentsAnswers
): Record<string, unknown> => ({
  accept_agb: answers.acceptAgb,
  accept_privacy: answers.acceptPrivacy,
  accept_guideline: answers.acceptGuideline,
  contact_via_email: answers.contactViaEmail,
  contact_via_whatsapp: answers.contactViaWhatsapp,
  accept_confirm_data: answers.acceptConfirmData,
})

/**
 * Persist chat legal consents via the onboarding tool. `chatLegalConsents` is
 * assigned only after the tool reports success so a failed/false result cannot
 * suppress the review-step iubenda fallback.
 */
export async function applyChatLegalConsents(
  store: ChatLegalConsentsApplyStore,
  answers: ChatLegalConsentsAnswers
): Promise<boolean> {
  try {
    const persisted = await store.applyOnboardingWidgetTool(
      'legal_consents',
      toLegalConsentsToolData(answers)
    )
    if (persisted === true) {
      store.chatLegalConsents = { ...answers }
      return true
    }
    return false
  } catch {
    return false
  }
}
